import type { Model } from '@patsnap/tahiti-core';
import type { EmbodimentClaimFeaturesState } from '../types';

export const EmbodimentClaimFeaturesModel = Symbol.for('EmbodimentClaimFeaturesModel');

export interface EmbodimentClaimFeaturesModel extends Model<EmbodimentClaimFeaturesState> {}
